// 出价兼容逻辑
const MULTIPLE = 1000
// 计算数据的京都
function rounding (number, fractionDigits) {
  return (!isNaN(number) && !isNaN(fractionDigits)) ? (Math.round(number * Math.pow(10, fractionDigits)) / Math.pow(10, fractionDigits)).toFixed(fractionDigits) : ''
}
Vue.mixin({
  methods: {
    resetBid (data) {
      // 如果是cpv的话。* 1000展示
      let info = Object.assign({}, data)
      if (info && (info.pricing_name === 'CPV' || info.pricing === 'CPV')) {
        info.bid = rounding(info.bid * MULTIPLE, 2)
      }
      return info
    },
    resetBidNumber (bid, mode) {
      // 如果是cpv的话。* 1000展示
      if (mode === 10) {
        bid = rounding(bid * MULTIPLE, 2)
      }
      return bid
    },
    sendBid (bid, pricing) {
      bid = bid || 0
      // 满足范围，在操作
      if (pricing === 'CPV' || pricing === 10) {
        bid = bid / MULTIPLE
        return +rounding(Number(bid), 5)
      }
      return +rounding(Number(bid), 2)
    }
  }
})
